import { Component, OnInit, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-bx-dailog',
  templateUrl: './bx-dailog.component.html',
  styleUrls: ['./bx-dailog.component.scss'],
})
export class BxDailog implements OnInit {
  emailForm: UntypedFormGroup;

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<BxDailog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.emailForm = this._fb.group({
      email: [
        '',
        [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')],
      ],
    });
  }

  saveEmailForm(form) {
    const message = {
      email: form.value.email,
      answer: 'yes',
    };
    this._dialogRef.close(message);
  }

  close() {
    const message = {
      answer: 'close',
    };
    this._dialogRef.close(message);
  }
}
